import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { FolderList } from "@/components/folder/FolderList";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";

export const FoldersPage = () => {
  const groupSlug = useGroupSlug();
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();

  if (!groupUuid || !groupSlug || !kitUuid) {
    return null;
  }

  return (
    <Page>
      <PageHeader>
        <PageHeader.Title>Knowledge</PageHeader.Title>
      </PageHeader>

      <PageBody>
        <FolderList
          groupSlug={groupSlug}
          groupUuid={groupUuid}
          kitUuid={kitUuid}
        />
      </PageBody>
    </Page>
  );
};
